module.exports = __webpack_public_path__ + "img/last_button_to_hem.482d75db.png";